import { format, parseISO } from 'date-fns'
import money from '@/mixins/money'
let hiaFilters = {
  methods: {
    filterList: function (array, criteria, columns = [], noDeleteFalsy = false) {
      // set array keys
      if ((array) && array.length) {
        let objKeys = Object.keys(array[0])
        let objKeysLength = objKeys.length
        let response = []
        // filter on every key for the given criteria
        response = array.filter(function (obj) {
          // delete falsy attributes in this obj
          if (!noDeleteFalsy) {
            for (let j = 0; j < objKeysLength; j++) {
              if (obj.hasOwnProperty(objKeys[j]) && obj[objKeys[j]] !== 0 && !obj[objKeys[j]]) {
                delete obj[objKeys[j]]
              }
            }
          }

          // return match
          for (let i in obj) {
            // column check flag
            let col = true
            if (columns.length && !columns.some(x => x === i)) {
              col = false
            }

            // skip arrays and objects
            if (!hiaFilters.methods.isArrayObject(obj[i])) {
              // column flag
              if (col) {
                let regEx = new RegExp(`${hiaFilters.methods.escapeRegExp(criteria)}`, 'ig')
                // convert to HIA date format if date

                if (!noDeleteFalsy) {
                  if (!isNaN(Date.parse(obj[i].toString())) && isNaN(obj[i])) {
                    try {
                      let dt = parseISO(obj[i].toString())
                      if (dt) {
                        let dateString = format(dt, 'M/d/yyyy hh:mm a')
                        if (dateString.toString().toLowerCase().match(regEx)) {
                          return obj
                        }
                      }
                    } catch (e) {
                      // do nothing...this is just a try parse and its ok if it fails
                    }
                  }
                }

                // is decimal
                if (typeof (obj[i]) !== typeof (String())) {
                  let decimalString = ''
                  let checkDecimal = (obj[i] - Math.floor(obj[i])) !== 0
                  let sigFigCheck = checkDecimal ? obj[i].toString().split('.')[1].length : 0
                  // percentage values have more than 2 sig figs
                  if (checkDecimal && sigFigCheck > 2) {
                    decimalString = `${(obj[i] * 100).toFixed(2)}%`
                  }
                  // most HIA dollar figures come back with 2 sig figs
                  if (checkDecimal && sigFigCheck === 2) {
                    decimalString = `$${money.methods.formatMoney(obj[i])}`
                  }
                  // check for 100%
                  if (`${(obj[i] * 100).toFixed(2)}%` === '100.00%') {
                    decimalString = `${(obj[i] * 100).toFixed(2)}%`
                  }

                  if (decimalString.toString().toLowerCase().match(regEx)) {
                    return obj
                  }
                }

                if (obj[i] && obj[i].toString().toLowerCase().match(regEx)) {
                  return obj
                }
              }
            }
          }
        })

        return response
      }
      return []
    },
    highlightValue: function (value, criteria) {
      if (value === '<Not Specified>') {
        value = '&lt;Not Specified&gt;'
      }

      if (!criteria.length) {
        return value
      }

      if (!hiaFilters.methods.isArrayObject(value) && value !== undefined) {
        let regEx = new RegExp(`${hiaFilters.methods.escapeRegExp(criteria)}`, 'ig')

        let findme = value.toString().match(regEx)
        let dedupe = [...new Set(findme)]
        for (let l in dedupe) {
          let regEx2 = new RegExp(hiaFilters.methods.escapeRegExp(dedupe[l]), 'g')
          value = value.toString().replace(regEx2, `<span style="background: rgba(255,255,0,1);padding: 0px 0px 0px 0px">${dedupe[l]}</span>`)
        }
        return value
      }
    },
    boolSortComparer(prop) {
      return (a, b) => {
        let a1 = !!a[prop]
        let b1 = !!b[prop]

        if (a1 < b1) {
          return 1
        }
        if (a1 > b1) {
          return -1
        }
        return 0
      }
    },
    isArrayObject: function (value) {
      if (Array.isArray(value)) { return true }
      if (value && typeof value === 'object' && value.constructor === Object) { return true }
    },
    escapeRegExp: function (text) {
      return text.replace(/[-[\]{}()*+?.,\\/^$|#\s]/g, '\\$&')
    }
  }
}

export default hiaFilters
